import { __module as r } from "../../../_virtual/isIdentityCard.js";
import { a as t } from "./util/assertString.js";
import { i as e } from "./isInt.js";
!function (r, n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n.default = function (r, t) {
    if ((0, u.default)(r), t in i) return i[t](r);
    if ("any" === t) {
      for (var e in i) if (i.hasOwnProperty(e) && (0, i[e])(r)) return !0;
      return !1;
    }
    throw Error("Invalid locale '".concat(t, "'"));
  };
  var u = s(t),
    a = s(e);
  function s(r) {
    return r && r.__esModule ? r : {
      default: r
    };
  }
  var i = {
    PL: function PL(r) {
      (0, u.default)(r);
      var t = {
        1: 1,
        2: 3,
        3: 7,
        4: 9,
        5: 1,
        6: 3,
        7: 7,
        8: 9,
        9: 1,
        10: 3,
        11: 0
      };
      if (null != r && 11 === r.length && (0, a.default)(r, {
        allow_leading_zeroes: !0
      })) {
        var e = r.split("").slice(0, -1).reduce(function (r, e, n) {
            return r + Number(e) * t[n + 1];
          }, 0) % 10,
          n = Number(r.charAt(r.length - 1));
        if (0 === e && 0 === n || n === 10 - e) return !0;
      }
      return !1;
    },
    ES: function ES(r) {
      (0, u.default)(r);
      var t = {
          X: 0,
          Y: 1,
          Z: 2
        },
        e = r.trim().toUpperCase();
      if (!/^[0-9X-Z][0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKE]$/.test(e)) return !1;
      var n = e.slice(0, -1).replace(/[X,Y,Z]/g, function (r) {
        return t[r];
      });
      return e.endsWith(["T", "R", "W", "A", "G", "M", "Y", "F", "P", "D", "X", "B", "N", "J", "Z", "S", "Q", "V", "H", "L", "C", "K", "E"][n % 23]);
    },
    FI: function FI(r) {
      return (0, u.default)(r), !!(11 === r.length && r.match(/^\d{6}[\-A\+]\d{3}[0-9ABCDEFHJKLMNPRSTUVWXY]{1}$/)) && "0123456789ABCDEFHJKLMNPRSTUVWXY"[(1e3 * parseInt(r.slice(0, 6), 10) + parseInt(r.slice(7, 10), 10)) % 31] === r.slice(10, 11);
    },
    IN: function IN(r) {
      var t = [[0, 1, 2, 3, 4, 5, 6, 7, 8, 9], [1, 2, 3, 4, 0, 6, 7, 8, 9, 5], [2, 3, 4, 0, 1, 7, 8, 9, 5, 6], [3, 4, 0, 1, 2, 8, 9, 5, 6, 7], [4, 0, 1, 2, 3, 9, 5, 6, 7, 8], [5, 9, 8, 7, 6, 0, 4, 3, 2, 1], [6, 5, 9, 8, 7, 1, 0, 4, 3, 2], [7, 6, 5, 9, 8, 2, 1, 0, 4, 3], [8, 7, 6, 5, 9, 3, 2, 1, 0, 4], [9, 8, 7, 6, 5, 4, 3, 2, 1, 0]],
        e = [[0, 1, 2, 3, 4, 5, 6, 7, 8, 9], [1, 5, 7, 6, 2, 8, 3, 0, 9, 4], [5, 8, 0, 3, 7, 9, 6, 1, 4, 2], [8, 9, 1, 6, 0, 4, 3, 5, 2, 7], [9, 4, 5, 3, 1, 2, 6, 8, 7, 0], [4, 2, 8, 6, 5, 7, 3, 9, 0, 1], [2, 7, 9, 3, 8, 0, 6, 4, 1, 5], [7, 0, 4, 6, 9, 1, 3, 2, 5, 8]],
        n = r.trim();
      if (!/^[1-9]\d{3}\s?\d{4}\s?\d{4}$/.test(n)) return !1;
      var u = 0;
      return n.replace(/\s/g, "").split("").map(Number).reverse().forEach(function (r, n) {
        u = t[u][e[n % 8][r]];
      }), 0 === u;
    },
    IR: function IR(r) {
      if (!r.match(/^\d{10}$/) || 0 === parseInt((r = "0000".concat(r).substr(r.length - 6)).substr(3, 6), 10)) return !1;
      for (var t = parseInt(r.substr(9, 1), 10), e = 0, n = 0; n < 9; n++) e += parseInt(r.substr(n, 1), 10) * (10 - n);
      return (e %= 11) < 2 && t === e || e >= 2 && t === 11 - e;
    },
    IT: function IT(r) {
      return 9 === r.length && "CA00000AA" !== r && r.search(/C[A-Z][0-9]{5}[A-Z]{2}/i) > -1;
    },
    NO: function NO(r) {
      var t = r.trim();
      if (isNaN(Number(t)) || 11 !== t.length || "00000000000" === t) return !1;
      var e = t.split("").map(Number),
        n = (11 - (3 * e[0] + 7 * e[1] + 6 * e[2] + 1 * e[3] + 8 * e[4] + 9 * e[5] + 4 * e[6] + 5 * e[7] + 2 * e[8]) % 11) % 11,
        u = (11 - (5 * e[0] + 4 * e[1] + 3 * e[2] + 2 * e[3] + 7 * e[4] + 6 * e[5] + 5 * e[6] + 4 * e[7] + 3 * e[8] + 2 * n) % 11) % 11;
      return n === e[9] && u === e[10];
    },
    TH: function TH(r) {
      if (!r.match(/^[1-8]\d{12}$/)) return !1;
      for (var t = 0, e = 0; e < 12; e++) t += parseInt(r[e], 10) * (13 - e);
      return r[12] === ((11 - t % 11) % 10).toString();
    },
    LK: function LK(r) {
      return !!(10 === r.length && /^[1-9]\d{8}[vx]$/i.test(r)) || !!(12 === r.length && /^[1-9]\d{11}$/i.test(r));
    },
    "he-IL": function heIL(r) {
      var t = r.trim();
      if (!/^\d{9}$/.test(t)) return !1;
      for (var e, n = 0, u = 0; u < t.length; u++) n += (e = Number(t[u]) * (u % 2 + 1)) > 9 ? e - 9 : e;
      return n % 10 == 0;
    },
    "ar-LY": function arLY(r) {
      var t = r.trim();
      return !!/^(1|2)\d{11}$/.test(t);
    },
    "ar-TN": function arTN(r) {
      var t = r.trim();
      return !!/^\d{8}$/.test(t);
    },
    "zh-CN": function zhCN(r) {
      var t,
        e,
        n = ["11", "12", "13", "14", "15", "21", "22", "23", "31", "32", "33", "34", "35", "36", "37", "41", "42", "43", "44", "45", "46", "50", "51", "52", "53", "54", "61", "62", "63", "64", "65", "71", "81", "82", "91"],
        u = ["7", "9", "10", "5", "8", "4", "2", "1", "6", "3", "7", "9", "10", "5", "8", "4", "2"],
        a = ["1", "0", "X", "9", "8", "7", "6", "5", "4", "3", "2"],
        s = function s(r) {
          return n.includes(r);
        },
        i = function i(r) {
          var t = parseInt(r.substring(0, 4), 10),
            e = parseInt(r.substring(4, 6), 10),
            n = parseInt(r.substring(6), 10),
            u = new Date(t, e - 1, n);
          if (u > new Date()) ;else if (u.getFullYear() === t && u.getMonth() === e - 1 && u.getDate() === n) return !0;
          return !1;
        };
      return !!/^\d{15}|(\d{17}(\d|x|X))$/.test(r) && (15 === r.length ? !!(/^[1-9]\d{7}((0[1-9])|(1[0-2]))((0[1-9])|([1-2][0-9])|(3[0-1]))\d{3}$/.test(r) && s(r.substring(0, 2)) && i("19".concat(r.substring(6, 12)))) : !!(/^[1-9]\d{5}[1-9]\d{3}((0[1-9])|(1[0-2]))((0[1-9])|([1-2][0-9])|(3[0-1]))\d{3}(\d|x|X)$/.test(r) && s(r.substring(0, 2)) && i(r.substring(6, 14))) && function (r) {
        for (var t = r.substring(0, 17), e = 0, n = 0; n < 17; n++) e += parseInt(t.charAt(n), 10) * parseInt(u[n], 10);
        return a[e % 11];
      }(r) === r.charAt(17).toUpperCase());
    },
    "zh-TW": function zhTW(r) {
      var t = {
          A: 10,
          B: 11,
          C: 12,
          D: 13,
          E: 14,
          F: 15,
          G: 16,
          H: 17,
          I: 34,
          J: 18,
          K: 19,
          L: 20,
          M: 21,
          N: 22,
          O: 35,
          P: 23,
          Q: 24,
          R: 25,
          S: 26,
          T: 27,
          U: 28,
          V: 29,
          W: 32,
          X: 30,
          Y: 31,
          Z: 33
        },
        e = r.trim().toUpperCase();
      return !!/^[A-Z][0-9]{9}$/.test(e) && Array.from(e).reduce(function (r, e, n) {
        if (0 === n) {
          var u = t[e];
          return u % 10 * 9 + Math.floor(u / 10);
        }
        return 9 === n ? (10 - r % 10 - Number(e)) % 10 == 0 : r + Number(e) * (9 - n);
      }, 0);
    }
  };
  r.exports = n.default, r.exports.default = n.default;
}(r, r.exports);
var n = r.exports;
export { n as i };